<!--
 * @Description: 基础库、应用库专家详情页
 * @Author: 钱磊
 * @Date: 2022-07-26 14:43:46
 * @LastEditors: wuxuebing
 * @LastEditTime: 2023-05-27 10:08:12
-->

<template>
	<div class="expert-info-main">
		<!-- <div class="header-note">
			注：专家本人须承诺提交至平台的信息真实可靠，否则会承担相应法律责任
		</div> -->
		<el-collapse v-model="activeNames">
			<el-collapse-item title="基础信息" name="1">
				<div class="expert-content h100">
					<el-form :model="personForm" label-width="170px" size="small" ref="personForm" :show-message="false">
						<el-row>
							<el-col :span="11">
								<el-form-item label="姓名：">
									{{ personForm.sname }}
								</el-form-item>
							</el-col>
							<el-col :span="11" :offset="1">
								<el-form-item label="性别：">
									{{ personForm.sex }}
								</el-form-item>
							</el-col>
						</el-row>
						<el-row>
							<el-col :span="11">
								<el-form-item label="证件类型：">
									{{ personForm.cardType }}
								</el-form-item>
							</el-col>
							<el-col :span="11" :offset="1">
								<el-form-item label="证件号码：">
									{{ personForm.cardNo }}
								</el-form-item>
							</el-col>
							<el-col :span="11">
								<el-form-item label="手机号：">
									{{ personForm.phone }}
								</el-form-item>
							</el-col>
							<el-col :span="11" :offset="1">
								<el-form-item label="年龄：">
									{{ personForm.age }}
								</el-form-item>
							</el-col>
						</el-row>
						<el-row>
							<el-col :span="11">
								<el-form-item label="毕业院校：">
									{{ personForm.academy }}
								</el-form-item>
							</el-col>
							<el-col :span="11" :offset="1">
								<el-form-item label="工作开始年份：" prop="proYears"> {{ personForm.proYears }}年 </el-form-item>
							</el-col>
						</el-row>
						<el-row>
							<el-col :span="11">
								<el-form-item label="所属地区：" prop="addressObj">
									{{ personForm.areaName }}
								</el-form-item>
							</el-col>
							<el-col :span="11" :offset="1">
								<el-form-item label="最高学历：">
									{{ personForm.education }}
								</el-form-item>
							</el-col>
							<el-col :span="11">
								<el-form-item label="现工作单位：">
									{{ personForm.unitName }}
								</el-form-item>
							</el-col>
							<el-col :span="11" :offset="1">
								<el-form-item label="邮箱：" prop="email">
									{{ personForm.email }}
								</el-form-item>
							</el-col>
							<el-col :span="11">
								<el-form-item label="职务：" prop="post">
									{{ personForm.post }}
								</el-form-item>
							</el-col>
							<el-col :span="11" :offset="1">
								<el-form-item label="部门：" prop="department">
									{{ personForm.department }}
								</el-form-item>
							</el-col>
							<el-col :span="23">
								<el-form-item label="规避单位">
									{{ personForm.evadeNames }}
								</el-form-item>
							</el-col>
						</el-row>
						<el-row>
							<el-col :span="11">
								<el-form-item label="个人一寸照片：" required>
									<div class="upload-item">
										<public-upload
											ref="yc_pic"
											isViewMode
											:viewFilesList="chioseFile('yc_pic')"
											listType="picture-card"
										></public-upload>
									</div>
								</el-form-item>
							</el-col>
						</el-row>
						<el-row>
							<el-col :span="24">
								<el-form-item label="证件照片：" required>
									<div class="flex">
										<div class="upload-item1">
											<public-upload
												ref="idcard_1"
												isViewMode
												:viewFilesList="chioseFile('idcard_1')"
												listType="picture-card"
											></public-upload>
											<div class="top-item-text2">身份证人像面</div>
										</div>
										<div class="upload-item1">
											<public-upload
												ref="idcard_2"
												isViewMode
												:viewFilesList="chioseFile('idcard_2')"
												listType="picture-card"
											></public-upload>
											<div class="top-item-text2">身份证国徽面</div>
										</div>
									</div>
								</el-form-item>
							</el-col>
						</el-row>
						<!-- 省级及以上专家聘书列表 -->
						<div class="file-row">
							<el-row v-for="(item, index) in zjpsList" :key="'聘书' + index">
								<el-col :span="7">
									<el-form-item label="省级及以上专家聘书：">
										<div class="upload-item">
											<public-upload
												:ref="`eduction${index}`"
												:viewFilesList="item.fileObject ? [item.fileObject] : []"
												isViewMode
												listType="picture-card"
											></public-upload>
										</div>
									</el-form-item>
								</el-col>
								<el-col :span="14">
									<el-row>
										<el-col :span="8">
											<el-form-item label="颁发单位：">
												{{ item.issueUnit }}
											</el-form-item>
										</el-col>
										<el-col :span="8">
											<el-form-item label="颁发时间：">
												{{ item.issueDate | timeFilter }}
											</el-form-item>
										</el-col>
										<el-col :span="8">
											<el-form-item label="有效期至：">
												{{ item.dueDate | timeFilter }}
											</el-form-item>
										</el-col>
									</el-row>
								</el-col>
							</el-row>
						</div>
						<!-- 学历列表 -->
						<div class="file-row">
							<el-row v-for="(item, index) in eductionList" :key="'学历' + index">
								<el-col :span="7">
									<el-form-item label="学历证书：">
										<div class="upload-item">
											<public-upload
												:ref="`eduction${index}`"
												:viewFilesList="item.fileObject ? [item.fileObject] : []"
												isViewMode
												listType="picture-card"
											></public-upload>
										</div>
									</el-form-item>
								</el-col>
								<el-col :span="7">
									<el-form-item label="学历：">
										{{ item.educationName }}
									</el-form-item>
								</el-col>
								<el-col :span="7">
									<el-form-item label="专业：">
										{{ item.profession }}
									</el-form-item>
								</el-col>
							</el-row>
						</div>
						<!-- 职称列表 -->
						<div class="file-row">
							<el-row v-for="(item, index) in careerList" :key="'职称' + index">
								<el-col :span="7">
									<el-form-item label="职称证书：">
										<div class="upload-item">
											<public-upload
												:ref="`career${index}`"
												:viewFilesList="item.fileObject ? [item.fileObject] : []"
												isViewMode
												listType="picture-card"
											></public-upload>
										</div>
									</el-form-item>
								</el-col>
								<el-col :span="7">
									<el-form-item label="职称：">
										{{ item.gradeName }}
									</el-form-item>
								</el-col>
								<el-col :span="7">
									<el-form-item label="职称专业：">
										{{ item.qualifieds }}
									</el-form-item>
								</el-col>
							</el-row>
						</div>
						<!-- 执业资格列表 -->
						<div class="file-row">
							<el-row v-for="(item, index) in licenseList" :key="'执业资格' + index">
								<el-col :span="7">
									<el-form-item label="执业资格证书：">
										<div class="upload-item">
											<public-upload
												:ref="`license${index}`"
												:viewFilesList="item.fileObject ? [item.fileObject] : []"
												isViewMode
												listType="picture-card"
											></public-upload>
										</div>
									</el-form-item>
								</el-col>
								<el-col :span="7">
									<el-form-item label="执业资格：">
										{{ item.typeName }}
									</el-form-item>
								</el-col>
								<el-col :span="7">
									<el-form-item label="登记专业：">
										{{ item.professionName == 'null' ? '' : item.professionName }}
									</el-form-item>
								</el-col>
							</el-row>
						</div>
						<!-- 其它证书列表 -->
						<div class="file-row">
							<el-row v-for="(item, index) in otherList" :key="'其它证书' + index">
								<el-col :span="7">
									<el-form-item label="其它证书：">
										<div class="upload-item">
											<public-upload
												:ref="`other${index}`"
												:viewFilesList="item.fileObject ? [item.fileObject] : []"
												isViewMode
												listType="picture-card"
											></public-upload>
										</div>
									</el-form-item>
								</el-col>
								<el-col :span="7">
									<el-form-item label="证书名称：">
										{{ item.certificateName }}
									</el-form-item>
								</el-col>
								<el-col :span="7">
									<el-form-item label="发证单位：">
										{{ item.issueUnit }}
									</el-form-item>
								</el-col>
							</el-row>
						</div>
						<el-row>
							<el-col :span="23">
								<el-form-item label="个人履历介绍：">
									{{ personForm.intro }}
								</el-form-item>
							</el-col>
						</el-row>
					</el-form>
				</div>
			</el-collapse-item>
			<el-collapse-item title="已加入专家库" name="2">
				<div class="pdl10 pdr10 mt10">
					<vxe-table
						align="center"
						border
						auto-resize
						:data="joinedLibList"
						show-header-overflow="tooltip"
						show-footer-overflow="tooltip"
						show-overflow="tooltip"
					>
						<vxe-table-column type="seq" title="序号" align="center" width="70"></vxe-table-column>
						<vxe-table-column title="状态" field="status">
							<template #default="{ row }">
								<span class="blue" v-if="row.status == 1">启用</span>
								<span class="red" v-if="row.status == 0">禁用</span>
							</template>
						</vxe-table-column>
						<vxe-table-column title="专家库名称" field="sname"></vxe-table-column>
						<vxe-table-column title="专业类别" field="specialtyName">
							<template v-slot="{ row }">
								{{ row.specialtyName | specialChange }}
							</template>
						</vxe-table-column>
						<vxe-table-column title="服务范围" field="areaName">
							<template v-slot="{ row }">
								{{ row.areaName | specialChange }}
							</template>
						</vxe-table-column>
						<vxe-table-column title="主要参评经验" field="projectExp"></vxe-table-column>
						<vxe-table-column title="审核人" field="updateUser"></vxe-table-column>
						<vxe-table-column title="审核时间" field="updateDate"></vxe-table-column>
					</vxe-table>
				</div>
			</el-collapse-item>
			<el-collapse-item title="变更记录" name="3">
				<div class="pdl10 pdr10 mt10">
					<p>信息变更审核记录</p>
					<vxe-table
						align="center"
						border
						auto-resize
						:data="changes"
						show-header-overflow="tooltip"
						show-footer-overflow="tooltip"
						show-overflow="tooltip"
					>
						<vxe-table-column type="seq" title="序号" align="center" width="70"></vxe-table-column>
						<vxe-table-column title="修改时间" field="createDate"></vxe-table-column>
						<vxe-table-column title="修改模块" field="changeModel"></vxe-table-column>
						<vxe-table-column title="标题" field="title"></vxe-table-column>
						<vxe-table-column title="原内容" field="beforeContent"></vxe-table-column>
						<vxe-table-column title="变更后内容" field="afterContent"></vxe-table-column>
						<vxe-table-column title="变更原因" field="reason"></vxe-table-column>
						<vxe-table-column title="审核人" field="updateUser"></vxe-table-column>
						<vxe-table-column title="审核时间" field="updateDate"></vxe-table-column>
						<vxe-table-column title="审核意见" field="remark"></vxe-table-column>
						<vxe-table-column title="状态" field="status">
							<template #default="{ row }">
								<span v-if="row.status == 0">待审核</span>
								<span v-else-if="row.status == 1">审核通过</span>
								<span v-else>驳回</span>
							</template>
						</vxe-table-column>
					</vxe-table>
					<p>状态变更记录</p>
					<vxe-table
						align="center"
						border
						auto-resize
						:data="statusChanges"
						show-header-overflow="tooltip"
						show-footer-overflow="tooltip"
						show-overflow="tooltip"
					>
						<vxe-table-column type="seq" title="序号" align="center" width="70"></vxe-table-column>
						<vxe-table-column title="原状态" field="beforeStatus">
							<template #default="{ row }">
								<span v-if="row.beforeStatus == 1">启用</span>
								<span v-if="row.beforeStatus == 0">禁用</span>
							</template>
						</vxe-table-column>
						<vxe-table-column title="变更后状态" field="afterStatus">
							<template #default="{ row }">
								<span v-if="row.afterStatus == 1">启用</span>
								<span v-if="row.afterStatus == 0">禁用</span>
							</template>
						</vxe-table-column>
						<vxe-table-column title="原因" field="changeReason"></vxe-table-column>
						<vxe-table-column title="备注原因" field="remark"></vxe-table-column>
						<vxe-table-column title="附件">
							<template v-slot="{ row }">
								<public-upload
									ref="enclosure"
									class="enclosure"
									v-if="row.fileObject"
									listType="text"
									:viewFilesList="row.fileObject ? [row.fileObject] : []"
									isViewMode
								></public-upload>
								<span v-else>-</span>
							</template>
						</vxe-table-column>
						<vxe-table-column title="操作人" field="createUser"></vxe-table-column>
						<vxe-table-column title="操作时间" field="createDate"></vxe-table-column>
					</vxe-table>
				</div>
			</el-collapse-item>
		</el-collapse>
	</div>
</template>

<script>
import { getExpertDetail } from 'api/modules/expert_gz'
import addressForm from '@/views/operation-management/expert/addressForm'
import { mapState } from 'vuex'
export default {
	components: {
		addressForm
	},
	props: {
		expertId: {
			type: String,
			default: ''
		},
		libId: {
			type: String,
			default: ''
		}
	},
	filters: {
		specialChange(val) {
			if (val) {
				let values = val.replace(/,/g, '/')
				return values
			} else {
				return '-'
			}
		},
		timeFilter(val) {
			if (val) {
				return val.split(' ')[0]
			}
		}
	},
	data() {
		return {
			bg_red: false,
			activeNames: ['1', '2', '3'], //展开列集合
			personForm: {},
			avoidName: '', //规避单位名
			zjpsList: [], //省级及以上专家聘书
			eductionList: [{}], // 学历列表
			careerList: [{}], // 职称列表
			licenseList: [{}], // 职业资格列表
			otherList: [{}], // 其它证书列表
			joinedLibList: [], //已加入专家库
			changes: [], //信息变更审核记录
			statusChanges: [], //状态变更记录
			allFiles: [], //所有附件
			viewFilesList: [] //图片的数据
		}
	},
	created() {
		// 获取全部基本信息
		this.getAllInfo()
	},
	mounted() {},
	methods: {
		//专家申请记录
		getExpertInfoHistory() {},

		// 初始回显信息
		getAllInfo() {
			let params = {
				id: this.expertId,
				libId: this.libId
			}
			getExpertDetail(params).then((res) => {
				if (res.operationCode === 1) {
					this.personForm = Object.assign({}, res.data.userInfo)
					this.zjpsList = res.data.zjps
					this.eductionList = res.data.educations
					this.careerList = res.data.practices
					this.licenseList = res.data.certificates
					this.otherList = res.data.otherCertificates
					this.joinedLibList = res.data.joinedLibList
					this.changes = res.data.changes
					this.statusChanges = res.data.statusChanges
					this.viewFilesList = res.data.userFiles
				}
			})
		},

		// 判断图片类型
		chioseFile(Type) {
			let data = {}
			switch (Type) {
				case 'yc_pic':
					data = this.viewFilesList.filter((x) => x.assortment == 'yc_pic')
					break
				case 'idcard_1':
					data = this.viewFilesList.filter((x) => x.assortment == 'idcard_1')
					break
				case 'idcard_2':
					data = this.viewFilesList.filter((x) => x.assortment == 'idcard_2')
					break
				case 'idcard_3':
					data = this.viewFilesList.filter((x) => x.assortment == 'idcard_3')
					break
				case 'cns':
					data = this.viewFilesList.filter((x) => x.assortment == 'cns')
					break
			}
			return data
		}
	},
	computed: {
		...mapState('user', {
			userInfo: (state) => state.userInfo
		})
	},
	watch: {}
}
</script>

<style scoped lang="less">
.expert-info-main {
	height: 100%;
	.header-note {
		height: 34px;
		line-height: 34px;
		padding: 0 13px;
		border: 1px solid #fbcdd1;
		font-size: 12px;
		color: #e60012;
		background: #fde6e6;
		margin-bottom: 13px;
	}

	.expert-content {
		background-color: #fff;
		padding: 20px;
		height: calc(~'100% - 48px - 20px');
		overflow-y: auto;
	}

	.file-row {
		background-color: #fafbfe;
		padding: 15px 0 0;
		margin-bottom: 15px;
	}

	.el-checkbox {
		margin-right: 24px !important;
	}

	.btn-tools {
		position: absolute;
		right: 30px;
		top: 10px;
		z-index: 10;

		.btn-icons {
			display: block;
			width: 40px;
			line-height: 40px;
			height: 40px;
			text-align: center;
			font-size: 20px;
			color: #fff;
			cursor: pointer;
		}

		.red-bg {
			background-color: #f44336;
		}

		.blue-bg {
			background-color: #409eff;
		}
	}

	.menu-block {
		height: 40px;
		line-height: 40px;
		background-color: #fafbfe;
		padding: 0 20px;
		font-size: 14px;
		color: #202020;
		margin-bottom: 10px;

		.text-color {
			font-size: 12px;
			color: #e60012;
			margin-left: 20px;
		}
	}
	.h100 {
		height: 100% !important;
	}
	.download-btn {
		vertical-align: bottom;
		margin-bottom: 18px;
		margin-left: 10px;
	}
}
.upload-item {
	width: 220px;
	height: 120px;
}
.upload-item1 {
	width: 220px;
}
.top-item-text2 {
	font-size: 12px;
	line-height: 30px;
	color: #666;
	text-align: center;
}
.footer {
	position: absolute;
	top: 88px;
	right: 135px;
	.el-button {
		height: 28px !important;
	}
}
.asq {
	/deep/ .el-cascader-menu__wrap {
		height: 340px;
	}
}
/deep/.el-collapse-item__header {
	font-size: 14px !important;
	font-weight: 600 !important;
	padding-left: 30px !important;
	background-color: #eff6fe !important;
	margin-top: 5px;
	height: 36px;
	line-height: 36px;
}
.enclosure {
	height: 24px !important;
}
.blue {
	color: #1388ba;
}
.red {
	color: red;
}
</style>
